








































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import Datatable from '@/components/datatables/Datatable.vue';
import AbstractDatatable from '@/zenky/datatables/AbstractDatatable';
import Order from '@/zenky/interfaces/orders/Order';
import DatatableRow from '@/zenky/datatables/DatatableRow';
import DatatableRowType from '@/zenky/datatables/DatatableRowType';
import { randomId } from '@/helpers';
import PaymentMethod from '@/zenky/interfaces/orders/PaymentMethod';
import { MapPinIcon } from 'vue-feather-icons';

@Component({
  components: {
    Datatable,
    MapPinIcon,
  },
})
export default class OrdersDatatable extends Vue {
  @Prop({ required: true }) readonly datatable!: AbstractDatatable;
  @Prop({ required: true }) readonly query!: Vue['$route']['query'];
  @Prop({ required: true, type: Array }) items!: Order[];
  @Prop({ required: true, type: Boolean }) loading!: boolean;
  @Prop({ required: true, type: Number }) totalPages!: boolean;

  protected sorting: any = {
    column: 'id',
    direction: 'asc',
  };

  protected baseTransitionDelay: number = 0.1;
  protected selection: string[] = [];

  get rows(): DatatableRow[] {
    return this.items.map((item: any) => ({
      item,
      id: `datatable-order-${item.id}`,
      type: DatatableRowType.DEFAULT,
      columns: [],
      hasActions: this.datatable.hasActions(),
      hasMultiselect: this.datatable.hasMultiSelectSupport(),
      actions: this.datatable.actions(item).map((action: any) => ({
        ...action,
        id: randomId('datatable-row-action'),
      })),
      defaultAction: this.datatable.defaultAction(item),
    }));
  }

  @Watch('loading')
  onLoadingChange(newVal: this['loading']) {
    if (newVal === true) {
      this.baseTransitionDelay = 0.1;
    } else {
      setTimeout(() => {
        this.baseTransitionDelay = 0;
      }, 100 * this.rows.length + 1);
    }
  }

  protected getPaymentIcon(method: PaymentMethod) {
    switch (method) {
      case PaymentMethod.CREDIT_CARD:
        return 'fa-credit-card';
      case PaymentMethod.CASH:
        return 'fa-money-bill-alt';
      case PaymentMethod.ONLINE:
        return 'fa-globe';
      default:
        return 'fa-credit-card';
    }
  }
}
